<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
    </d-card-header>

    <d-card-body class="px-0" v-if="model.id">
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-button class="btn-success btn-block" @click="printReport()">Relatório de indicações</d-button>
          <d-button v-if="!isReseller" class="btn-danger btn-block" @click="confirmDeleteRow()">
            <template v-if="model.deleted_at == null">
              <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Desabilitar Loja</span>
            </template>
            <template v-else>
              <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Habilitar Loja</span>
            </template>
          </d-button>
          <d-button v-if="!isReseller" class="btn-info btn-block" @click="blockAccess()">
            <template v-if="(model.status == 1)">
              <i class="fas fa-ban"></i><span class="d-none d-lg-inline"> Não indicar loja no site</span>
            </template>
            <template v-else>
              <i class="fas fa-check-circle"></i><span class="d-none d-lg-inline"> Liberar exibição no site</span>
            </template>
          </d-button>
        </d-list-group-item>

      </d-list-group>
    </d-card-body>
    <d-card-footer :class="(model.id) ? 'border-top' : ''">
      <d-button class="btn-primary btn-block" @click="save()">Salvar</d-button>
    </d-card-footer>
    <report-lead-modal/>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import config from '_config';
import Events from '_utils/events';
import ReportLeadModal from '_modules/reseller/components/modal/ReportLeadsModal.vue';
import { MODEL, _OPEN_CONFIRMATION_, _DELETE_RESELLER_, _REPORT_RESELLER_LEAD_ } from './ResellerModel';

export default {
  name: 'sidebar-actions',
  components: {
    ReportLeadModal,
  },
  props: {
    title: {
      type: String,
      default: 'Ações',
    },
    model: {
      type: Object,
      default: () => MODEL,
    },
  },
  computed: {
    isReseller() {
      const { user } = this.$store.state.user;
      if (user && user.settings.user_type_id === config.RESELLER_TYPE_ID) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    deleteProduct() {
      const params = {
        type: 'product',
        object: this.model,
        message: 'Produto deletado com sucesso!',
      };
      Events.$emit(_OPEN_CONFIRMATION_, params);
    },
    blockAccess() {
      this.$emit('blockAccess', this.model);
    },
    printReport() {
      this.setToggle({ type: 'report_lead_modal', bool: true });
      Events.$emit(_REPORT_RESELLER_LEAD_, this.model);
    },
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_RESELLER_, this.model);
    },
    save() {
      this.$emit('save', this.model);
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
i.material-icons {
  top: 5px;
}
</style>
